// ============================================================================
// CHANGO V5.0 — LayersChangeToast (§9.5.1 客户端自动刷新提示)
// ============================================================================
// 当 ops 后台改了客户的套餐, AuthContext 60 秒轮询检测到 `layers_revision`
// 变化时, 弹出此 toast。无 dirty form 时 3 秒自动刷新; 有 dirty form 时停留
// 让客户挑时机点"立即刷新"。
//
// 期望挂载位置: AppShell 顶部 (任何客户端都能看到), 不要进 RequireAuth 内部
// 因为冻结 / 复核状态变化也走这个机制。
// ============================================================================

import React from 'react';

import { useAuth } from '../hooks/useAuth.js';
import { brandForSku } from '../lib/skuBrandVersion.js';

export default function LayersChangeToast() {
  const { layersToast, reloadNow, dismissLayersToast } = useAuth();
  if (!layersToast) return null;

  const sku = brandForSku(layersToast.sku_code);
  const layers = Array.isArray(layersToast.enabled_layers)
    ? layersToast.enabled_layers.join(' + ')
    : '';

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed bottom-4 right-4 z-[60] max-w-sm rounded-lg border border-blue-300 bg-blue-50 p-4 shadow-lg"
    >
      <div className="flex items-start gap-3">
        <div className="mt-0.5 h-2 w-2 flex-shrink-0 rounded-full bg-blue-500 animate-pulse" />
        <div className="flex-1 text-sm">
          <p className="font-semibold text-slate-800">套餐已更新</p>
          <p className="mt-1 text-slate-600">
            您的工作区套餐已被平台调整为 <span className="font-semibold">{sku.shortName}</span>
            {layers && <span className="text-slate-400">（{layers}）</span>}。
          </p>
          <p className="mt-2 text-xs text-slate-500">
            建议刷新页面以解锁新功能。如有未保存的修改，请先保存再刷新。
          </p>
          <div className="mt-3 flex gap-2">
            <button
              type="button"
              onClick={reloadNow}
              className="rounded bg-blue-600 px-3 py-1.5 text-xs font-semibold text-white hover:bg-blue-700"
            >
              立即刷新
            </button>
            <button
              type="button"
              onClick={dismissLayersToast}
              className="rounded border border-slate-300 px-3 py-1.5 text-xs text-slate-700 hover:bg-slate-100"
            >
              稍后再说
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
